import PencilMemoEdit from "@/assets/PencilEdit";
import trackClevertapEvents from "@/utils/trackClevertapEvents";
import React, { useCallback, useEffect, useRef, useState } from "react";

import { RECOMMENDED } from "../dashboardTabs/constants/dashboardTabs";
import JobPreferencesEditCard from "./job-preferences-edit-card";

type DashboardHeaderProps = {
  isMobile: boolean;
  activeTab: string;
  jobPreferenceData: any;
  doNotRender: boolean;
};

const DashboardHeader = ({
  isMobile,
  activeTab,
  jobPreferenceData,
  doNotRender,
}: DashboardHeaderProps) => {
  const [isEditing, setIsEditing] = useState(false);
  const ref = useRef<HTMLFormElement>(null);
  const [localPreferenceData, setLocalPreferenceData] = useState(
    jobPreferenceData?.jobPreference,
  );

  const openPreferencesCard = () => {
    setIsEditing(true);
    const eventProps = {
      sourceOfClick: "Dashboard",
      sectionName: "Job Preferences",
      typeOfClick: "Edit",
    };
    trackClevertapEvents.eventPush("Profile Section Clicked", eventProps);
  };

  return (
    <>
      {!doNotRender ? (
        <div className={`flex items-center justify-between px-4 md:!px-0`}>
          {activeTab === RECOMMENDED && (
            <>
              {!isMobile && localPreferenceData && (
                <div className="flex w-full flex-col gap-4 rounded-lg border border-[#E8E8EB] bg-white p-4">
                  <div className="flex items-start justify-between gap-3">
                    <div className="text-sm font-bold leading-5 text-[#17142A]">
                      Make sure your preferences are correct!
                    </div>
                    <button onClick={openPreferencesCard} className="m-auto">
                      <PencilMemoEdit height="24" width="24" />
                    </button>
                  </div>
                  <div className="flex flex-col gap-6">
                    <div className="flex flex-col gap-1">
                      <div className="text-[12px] font-normal not-italic leading-[16px] text-[#777584]">
                        Preferred Role
                      </div>
                      <div className="text-[12px] font-medium not-italic leading-[16px] text-[#17142A]">
                        {Array.isArray(localPreferenceData.roles) &&
                        localPreferenceData.roles.length > 0
                          ? localPreferenceData.roles
                              .map((r: { text: string }) => r?.text)
                              .filter(Boolean)
                              .join(", ")
                          : "—"}
                      </div>
                    </div>

                    <div className="flex flex-col gap-1">
                      <div className="text-[12px] font-normal not-italic leading-[16px] text-[#777584]">
                        Preferred Location
                      </div>
                      <div className="text-[12px] font-medium not-italic leading-[16px] text-[#17142A]">
                        {Array.isArray(localPreferenceData.locations) &&
                        localPreferenceData.locations.length > 0
                          ? localPreferenceData.locations
                              .map((l: { text: string }) => l?.text)
                              .filter(Boolean)
                              .join(", ")
                          : "—"}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
          <JobPreferencesEditCard
            isEditing={isEditing}
            closeEdit={() => setIsEditing(false)}
            isMobile={isMobile}
            formRef={ref}
            prefilledData={jobPreferenceData}
            onSave={(updatedData) =>
              setLocalPreferenceData(updatedData.jobPreference)
            }
          />
        </div>
      ) : null}
    </>
  );
};
export default React.memo(DashboardHeader);
